import './index.scss';

(function ($) {
  const $component = $('.q-search-filters');
  let url;

  $('.js-search-filter-toggle', $component).click(function (evt) {
    $(this).next('.q-search-filters-content').toggleClass('q-filter-active');
    $(this).parent().toggleClass('q-search-btn-active');
    evt.preventDefault();
    evt.stopPropagation();
  });

  $('[name="filter_types"]', $component).on('change', e => {
    url = e.currentTarget.dataset.url;
  });

  $('.js-btn-search').on('click', function() {
    Turbolinks.visit(url);
  });

})(jQuery);
